import { designTokens as e } from "../design-tokens.js";
function n(r) {
  return `calc(${r}rem * 16 / var(${e.htmlFontSize.cssCustomProperty}))`;
}
function o(r) {
  return r ? r.includes("rem") ? Math.floor(
    parseFloat(r.replace("rem", "")) * Number(e.htmlFontSize.$value)
  ) : parseInt(r) : 0;
}
export {
  o as parseCssValue,
  n as toRem
};
